import { useEffect, useState } from "react";
import styles from '../styles/pokemon.module.scss';

export interface ICountTagProps {
    count: number;
    children: JSX.Element;
    left?: boolean;
    bottom?: boolean;
}

const wrap = {
      gridArea: "1 / 1",
      display: "grid",
      width: "100%",
      height: "100%"
};

const base = {
    gridArea: "1 / 1",
};

const overlay_tr = {
    gridArea: "1 / 1",
    justifySelf: "end",
    alignSelf: "start",
    marginTop: window.innerWidth > 960 ? 12 : 2,
    marginRight: 2,
    zIndex: 2
};

const overlay_tl = {
    gridArea: "1 / 1",
    justifySelf: "start",
    alignSelf: "end",
    marginTop: window.innerWidth > 960 ? 12 : 2,
    marginRight: 2,
    zIndex: 2
};

const overlay_br = {
    gridArea: "1 / 1",
    justifySelf: "end",
    alignSelf: "end",
    marginTop: window.innerWidth > 960 ? 12 : 2,
    marginRight: 2,
    zIndex: 2
};

const overlay_bl = {
    gridArea: "1 / 1",
    justifySelf: "start",
    alignSelf: "start",
    marginTop: window.innerWidth > 960 ? 12 : 2,
    marginRight: 2,
    zIndex: 2
};

const CountTag : React.FunctionComponent<ICountTagProps> = (props : ICountTagProps) => {
    const [count, setcount] = useState<number>(0);

    useEffect(() => {
        setcount(props.count);
    },[props.count]);

    return (
        <div style={wrap}>
            <div style={base}>
                {props.children}
            </div>
            <div style={props.left ? props.bottom ? overlay_tl 
                                                  : overlay_bl 
                                   : props.bottom ? overlay_br
                                                  : overlay_tr}>
                <ul className={`${props.left === true ? styles.reversetags : styles.tags} ${count ? styles.blueTag : styles.redTag}`}>
                    <li># {count ? props.count : 0}</li>
                </ul>
            </div>
        </div>
    );
}

export default CountTag;